//@ts-check
/// <reference path="./search.d.ts" />
(async function () {
        'use strict';

        //#region Constants

        /** @type {string} Name of the search input */
        const INPUT_NAME='search';

        /** @type {string} Name of the WordPress nonce input */
        const NONCE_NAME='_wpnonce';

        /** @type {string} Base class for all elements - using some quasi-BEM convention */
        const BASE_CLASS='main-header__search';

        //#endregion

        //#region Variables

        /** @type {AbortController} Controller to abort the `fetch` call */
        let controller=new AbortController();

        /** @type {boolean} Determines if the form is being submitted or not */
        let is_submitting=false;

        /** @type {string} Contains the text of the last search */
        let last_submit_search='';

        //#endregion

        //#region Early check if it is disabled

        if ( // Make sure that nothing runs if it's disabled ...
             !window.SEARCH_SETTINGS || !SEARCH_SETTINGS.enabled || // ... or there are no post types to search
             !SEARCH_SETTINGS.post_types?.length || // ... or there's no URL to send the POST request to

             !SEARCH_SETTINGS.url.length) {
            return;
        }

        //#endregion

        //#region Important elements

        /** @type {HTMLElement|null} The element that contains all elements */
        const dropdown=document.getElementById('header-search-dropdown');

        if ( !dropdown) {
            return;
        }

        /** @type {HTMLElement|null} The search `<form>` */
        const form=document.getElementById('header-search-form');

        /*
		The search may have been disabled
		This means the element won't exist
		That means we must flee!
		Those who stay are the Exception
		These are not ones to follow
	*/
        if ( !form || !(form instanceof HTMLFormElement)) {
            return;
        }

        /** @type {HTMLElement|null} The search `<input type="search">` field */
        const input=form.querySelector('input[type="search"][name="'+ CSS.escape(INPUT_NAME) + '"]');

        if ( !input || !(input instanceof HTMLInputElement)) {
            return;
        }

        /** @type {HTMLElement|null} The nonce field */
        const nonce=form.querySelector('input[type="hidden"][name="'+ CSS.escape(NONCE_NAME) + '"]');

        if ( !nonce || !(nonce instanceof HTMLInputElement)) {
            return;
        }

        //#endregion

        //#region Results elements

        /** @type {HTMLElement|null} The element that contains all the results and everything related */
        const results=dropdown.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results');

        if ( !results) {
            return;
        }

        /** @type {NodeListOf<HTMLButtonElement>} All close buttons inside the results */
        const results_close=results.querySelectorAll('button.'+ CSS.escape(BASE_CLASS) + '--results_close');

        if ( !results_close || !results_close.length) {
            return;
        }

        /** @type {HTMLElement|null} The element that holds the results list */
        const results_list=results.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results_list');

        if ( !results_list) {
            return;
        }

        /** @type {HTMLElement|null} The element that holds the results list */
        const results_list_content=results_list.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results_list_content');

        if ( !results_list_content) {
            return;
        }

        /** @type {HTMLElement|null} The element to show when the results list is empty */
        const results_empty=results.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results_empty');

        if ( !results_empty) {
            return;
        }

        /** @type {HTMLElement|null} The element to show when there was an error */
        const results_error=results.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results_error');

        if ( !results_error) {
            return;
        }

        /** @type {HTMLElement|null} The element to show when waiting */
        const results_loading=results.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results_loading');

        if ( !results_loading) {
            return;
        }

        /** @type {HTMLElement|null} The title element for search results */
        const results_title=document.getElementById('header-search-results-title');

        /** @type {HTMLElement|null} The title element for empty search results */
        const results_empty_title=document.getElementById('header-search-results-empty-title');

        /** @type {string} Store the original translated text for results title */
        const results_title_base = results_title ? results_title.textContent.trim() : 'Search results';

        /** @type {string} Store the original translated text for empty results title */
        const results_empty_title_base = results_empty_title ? results_empty_title.textContent.trim() : 'Search results';

        /**
         * Escapes HTML to prevent XSS attacks
         * @param {string} text
         * @returns {string}
         */
        const escape_html = function escape_html(text) {
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        };

        /** @type {HTMLElement|null} The template to use for the column in the results */
        const results_template_column=document.getElementById('header-search-results-column-template');

        if ( !results_template_column || !(results_template_column instanceof HTMLTemplateElement)) {
            return;
        }

        /** @type {HTMLElement|null} The template to use for the rows in the results */
        const results_template_row=document.getElementById('header-search-results-row-template');

        if ( !results_template_row || !(results_template_row instanceof HTMLTemplateElement)) {
            return;
        }

        //#endregion

        //#region Functions

        /**
	 * Hides the element(s) visually and from assistive tech
	 *
	 * @param {HTMLElement|Iterable<HTMLElement>} elem The element(s) to hide
	 *
	 * @returns {void}
	 */
        const hide_element=function hide_element(elem) {
            if (Symbol.iterator in elem) {
                Array.from(elem).forEach((elem)=> hide_element(elem));
            }

            else {
                elem.setAttribute('hidden', '');
                elem.setAttribute('aria-hidden', 'true');
            }
        }

        ;

        /**
	 * "Un-hides" the element(s) visually and from assistive tech
	 *
	 * @param {HTMLElement|Iterable<HTMLElement>} elem The element(s) to show
	 *
	 * @returns {void}
	 */
        const show_element=function show_element(elem) {
            if (Symbol.iterator in elem) {
                Array.from(elem).forEach((elem)=> show_element(elem));
            }

            else {
                elem.removeAttribute('hidden');
                elem.setAttribute('aria-hidden', 'false');
            }
        }

        ;

        //#endregion

        //#region Submit handling

        form.addEventListener('submit', async function form_submit_handler(e) {
                e.preventDefault();

                //#region Submit validation

                // We only handle trusted events from a button press
                if ( !e.isTrusted || !e.submitter) {
                    return;
                }

                /** @type {FormData} The data that will be submitted later */
                let formdata=new FormData(form, e.submitter);

                // Must have a search value or we can't do anything
                if ( !formdata.has(INPUT_NAME)) {
                    return;
                }

                /** @type {FormDataEntryValue|null} The search term, if any exists */
                let search=formdata.get(INPUT_NAME);

                // Must be a string, with an appropriate length
                if ( !search || search instanceof File || !search.length || search.length < Number.parseInt(SEARCH_SETTINGS.length.min.toString(), 10) || search.length > Number.parseInt(SEARCH_SETTINGS.length.max.toString(), 10)) {
                    return;
                }

                //#endregion

                //#region Submit preparation

                /*
			We need to check if we're already submitting
			This avoids collisions where the search results may be mangled or broken or incorrect
			
			If we don't do this, any of these scenarios is possible (and many more):
			- More than one of "no results", loading, error or results may be showing at the same time
			- Show the results of the 2nd search then the ones from the 1st search, and vice-versa
			- Show the results of both searches at the same time
		*/
                if (is_submitting) {

                    // If the search is the same, we can safely ignore
                    if (last_submit_search===search) {
                        return;
                    }

                    /*
				Cancel the last search and re-do it
				
				This can be extremely useful when you submit "spot" but meant "sport"
				If the request didn't finish, and the search was fixed, then it will cancel the "spot"
				With that, it will then proceed and search for "sport"
			*/
                    controller.abort();

                    // Give it time to process everything
                    // https://stackoverflow.com/questions/951021/what-is-the-javascript-version-of-sleep
                    await new Promise((r)=> setTimeout(r, 200));
                }

                is_submitting=true;
                last_submit_search=search;

                /*
			Must always have a fresh abort controller or it won't submit until the next refresh
			If this isn't refreshed, then the abort signal will always be triggered
			And on every single `fetch`, it will just ... not do it...
			Why? Because we probably ran `.abort()` before on this AbortController.
		*/
                controller=new AbortController();

                hide_element([results_list, results_empty, results_error]);

                show_element([results_loading, results]);

                /**
		 * Shows just the error element
		 *
		 * @return {void}
		 */
                const show_error=function show_error() {
                    hide_element([results_list, results_empty, results_loading]);

                    show_element(results_error);
                }

                ;

                //#endregion

                /** @todo Implement some caching */

                //#region Ajax submit

                try {

                    /** @type {Response} */
                    let result=await fetch(SEARCH_SETTINGS.url, {
                            method: 'post',
                            body: formdata,
                            signal: controller.signal,
                        }

                    );

                    //#region Ajax response handling

                    /** @todo Find a better way to clean this up */
                    is_submitting=false;

                    if ( !result.ok) {
                        show_error();
                        return;
                    }

                    /** @type {AjaxSearchResponse} */
                    let response=await result.json();

                    if ( !response.success) {
                        show_error();
                        return;
                    }

                    // Make sure the nonce is fresh, and none of that fresh frozen stuff...
                    if (response.data.nonce?.length) {
                        nonce.value=response.data.nonce;
                    }

                    // No total posts means empty result
                    if ( !response.data.total_posts) {
                        hide_element([results_list, results_empty, results_error, results_loading]);

                        // Update the empty results title with the search term
                        if (results_empty_title) {
                            const searchText = escape_html(String(search));
                            results_empty_title.innerHTML = results_empty_title_base + ': <span style="color: #1271A7;">' + searchText + '</span>';
                        }

                        show_element(results_empty);

                        return;
                    }

                    //#endregion

                    //#region Ajax data rendering

                    /** @type {DocumentFragment} Fragment that will host all nodes temporarily */
                    const fragment=new DocumentFragment();

                    for (let key of response.data.order) {
                        //#region Data rendering - column

                        let posts=response.data.posts[key] || [];

                        /** @type {DocumentFragment} */
                        //@ts-expect-error The cloned `Node` is a `DocumentFragment` - https://developer.mozilla.org/en-US/docs/Web/API/HTMLTemplateElement/content
                        let content_column=results_template_column.content.cloneNode(true);

                        /** @type {HTMLHeadingElement|null} */
                        let title=content_column.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results_column_title');

                        if ( !title) {
                            return;
                        }

                        // Singular is - usually - for just 1 item
                        title.textContent=response.data.titles[key] || '';

                        /** @type {HTMLElement|null} */
                        let column_list=content_column.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results_column_list');

                        if ( !column_list) {
                            return;
                        }

                        //#endregion

                        //#region Data rendering - row

                        posts .map(function (post) {
                                /** @type {DocumentFragment} */
                                //@ts-expect-error The cloned `Node` is a `DocumentFragment` - https://developer.mozilla.org/en-US/docs/Web/API/HTMLTemplateElement/content
                                let content_row=results_template_row.content.cloneNode(true);

                                /** @type {HTMLAnchorElement|null} */
                                let link=content_row.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results_row_link');

                                if ( !link) {
                                    return;
                                }

                                link.href=post.url;

                                /** @type {HTMLElement|null} */
                                let title=content_row.querySelector('.'+ CSS.escape(BASE_CLASS) + '--results_row_title');

                                if ( !title) {
                                    return;
                                }

                                title.textContent=post.title;

                                return content_row;
                            }

                        ) .filter((elem)=> elem instanceof DocumentFragment) .forEach((row)=> column_list.appendChild(row));

                        fragment.appendChild(content_column);

                        //#endregion
                    }

                    //#region Data rendering - presentation

                    // Removes all the children
                    while (results_list_content.firstChild) {
                        results_list_content.removeChild(results_list_content.firstChild);
                    }

                    results_list_content.appendChild(fragment);

                    // Update the title with the search term
                    if (results_title) {
                        const searchText = escape_html(String(search));
                        results_title.innerHTML = results_title_base + ': <span style="color: #1271A7;">' + searchText + '</span>';
                    }

                    hide_element(results_loading);
                    show_element(results_list);

                    //#endregion

                    //#endregion
                }

                catch (ex) {
                    //#region Ajax error/abort handling

                    /** @todo Find a better way to clean this up - where I don't repeat this */
                    is_submitting=false;

                    /** @todo Find a way to disable this in production */
                    console.error(ex);

                    if (ex instanceof Error) {
                        switch (ex.name ?? Error.name) {
                            /*
						The `AbortController` causes the `fetch` to throw an error
						This is the error is throws, as described here:
						https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort
						
						> Note: When abort() is called, the fetch() promise rejects with an Error of type DOMException, with name AbortError.
					*/
                            case 'AbortError': hide_element(results);
                            break;

                            // Any other error may happen
                            default: show_error();
                        }
                    }

                    //#endregion
                }

                //#endregion
            }

        );

        //#region

        //#region Toggle for mobile
            {
            /** @type {HTMLElement|null} The button to show/hide the dropdown for the mobile */
            const toggle=document.getElementById('header-search-toggle');

            if ( !toggle || !(toggle instanceof HTMLButtonElement)) {
                return;
            }

            let toggle_id=toggle.getAttribute('aria-controls');

            if ( !toggle_id) {
                return;
            }

            /** @type {HTMLElement|null} The mobile dropdown */
            const toggle_dropdown=document.getElementById(toggle_id);

            if ( !toggle_dropdown) {
                return;
            }

            /** @type {boolean} Last expanded status set by an human */
            let last_status=toggle.getAttribute('aria-expanded')==='true';

            /** @type {number} Maximum width for the dropdown to be visible at */
            const max_width=Number.parseInt(SEARCH_SETTINGS.dropdown_max_width.toString(), 10);

            /**
		 * Performs all the toggling operations
		 *
		 * @param {boolean} is_expanded If it is to expand or hide
		 * @param {boolean} [hide_button=true] Hide or keep the toggle button
		 *
		 * @returns {void}
		 */
            let toggle_fn=function toggle_fn(is_expanded, hide_button=true) {
                toggle.setAttribute('aria-expanded', is_expanded.toString());
                toggle.setAttribute('aria-hidden', is_expanded.toString());

                if (is_expanded) {

                    /** @todo Find a better way - like keeping the results visible when swapping between desktop and mobile? */
                    if (is_submitting) {
                        // Abort the search, or we will have issues
                        controller.abort();
                    }

                    show_element(toggle_dropdown);
                }

                else {
                    hide_element(toggle_dropdown);
                }

                if (hide_button) {
                    /*
					Prevents this warning in the console:
					> Blocked aria-hidden on an element because its descendant retained focus.
					> The focus must not be hidden from assistive technology users.
				*/
                    toggle.blur();

                    toggle.setAttribute('hidden', '');
                }

                else {
                    toggle.removeAttribute('hidden');
                }
            }

            ;

            /**
		 * Handles the resize event
		 *
		 * @returns {void}
		 */
            let resize_handler=function resize_handler() {
                if (window.innerWidth >=max_width) {
                    /** @todo Prevent running multiple times */
                    // Desktop: start collapsed (like mobile), keep toggle button visible
                    toggle_fn(false, false);
                    last_status=false;

                    // On desktop, show the buttons
                    show_element(results_close);
                }

                else if (window.innerWidth < max_width) {
                    /** @todo Prevent running multiple times */
                    toggle_fn(last_status, false);

                    // On mobile, hide the buttons
                    hide_element(results_close);
                }
            }

            ;

            /** @type {number|null} The RAF number or nothing - *MUST* be nulled after running */
            let raf=null;

            /** @todo Find a more performant way of doing this */
            window.addEventListener('resize', function (_) {
                    if (raf) {
                        return;
                    }

                    raf=requestAnimationFrame(function (_) {
                            raf=null;

                            resize_handler();
                        }

                    );
                }

            );

            resize_handler();

            toggle.addEventListener('click', function toggle_click_handler() {
                    last_status= !last_status;

                    toggle_fn(last_status, false);

                    if ( !last_status) {
                        // Abort any ajax requests when closing this
                        controller.abort();
                    }

                    /*
				If we don't hide this, then the results will just pop up on desktop sizes
				This makes for a very jarring experience, where the visitor expects the results to be collapsed
				
				Hiding the results solves the issue
			*/
                    hide_element(results);

                    if (last_status) {
                        input.focus();
                    }
                }

            );
        }

        //#endregion

        //#region Results - close button
            {

            /**
		 * Handles the click in the "Close" buttons inside the results
		 *
		 * @param {MouseEvent} e
		 *
		 * @returns {void}
		 */
            const close_handler=function close_handler(e) {
                // We must cancel any ongoing fetch
                controller.abort();

                if (e.target && e.target instanceof HTMLElement) {
                    /*
					Prevents warning:
					> Blocked aria-hidden on an element because its descendant retained focus.
					> The focus must not be hidden from assistive technology users.
				*/
                    e.target.blur();
                }

                hide_element(results);
            }

            ;

            results_close.forEach(function (button) {
                    button.addEventListener('click', close_handler);
                }

            );
        }

        //#endregion

        //#region Results - close on outside click
            {

            /**
		 * Handles clicks outside the search results to close them
		 *
		 * @param {MouseEvent} e
		 *
		 * @returns {void}
		 */
            const outside_click_handler=function outside_click_handler(e) {

                // Check if results are currently visible
                if (results.hasAttribute('hidden')) {
                    return;
                }

                // Check if the click was outside the results and the form
                if (e.target instanceof Node && !results.contains(e.target) && !form.contains(e.target)) {
                    // We must cancel any ongoing fetch
                    controller.abort();

                    hide_element(results);

                    // Only hide dropdown and update toggle on mobile
                    const max_width=Number.parseInt(SEARCH_SETTINGS.dropdown_max_width.toString(), 10);

                    if (window.innerWidth < max_width) {
                        hide_element(dropdown);

                        // Update mobile toggle button state
                        const toggle=document.getElementById('header-search-toggle');

                        if (toggle && toggle instanceof HTMLButtonElement) {
                            toggle.setAttribute('aria-expanded', 'false');
                        }
                    }
                }
            }

            ;

            document.addEventListener('click', outside_click_handler);
        }

        //#endregion
    }

)();